import React, { Component } from 'react';
import { Container, Row, Button, Col, Modal } from 'react-bootstrap';
import ProjEditNumberDom from './ProjEditNumberDom';
import ProjEditStringDom from './ProjEditStringDom';
import ProjEditTextareaDom from './ProjEditTextareaDom';
import ProjEditTimeDom from './ProjEditTimeDom';
import ProjEditPtypeDom from './ProjEditPtypeDom';
import ProjEditIntervalDom from './ProjEditIntervalDom';
import ProjEditImageDom from './ProjEditImageDom';
import ProjEditImageAryDom from './ProjEditImageAryDom';
import ProjAddCustTempImgs from './ProjAddCustTempImgs';
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import * as Icons from "@fortawesome/free-solid-svg-icons"
// import api from '../../api';

const ETYPE = {
    STRING: 0,
    NUMBER: 1,
    TIME: 2,
    OPTIONS: 3,
    EMPTY: 4,
    INTERVAL: 5,
    NO_DATA: 6,
    TEXT_AREA: 7,
    IMAGE: 8,
    IMAGE_ARY: 9
};

export default class ProjectsAddCustAppForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: props.formData,
            isDisabled: null == props.isDisabled ? true : props.isDisabled,
            tmpData: { ...props.formData },
            isShowImg: false
        };
        // if (false == this.state.isDisabled) {
        //     this.state.tmpData = this.state.data;
        // }
        console.log("[ProjectsAddCustAppForm] props", props, this.state);

        this.onChange = this.onChange.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.getDom = this.getDom.bind(this);
        this.onSwitchImgPopup = this.onSwitchImgPopup.bind(this);
        this.onSelectImg = this.onSelectImg.bind(this);
        this.onConfirmImg = this.onConfirmImg.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        console.log(nextProps, nextState);

        if (this.state.data != nextProps.formData) {
            this.setState({
                data: nextProps.formData,
                tmpData: { ...nextProps.formData }
            });
            return false;
        }

        return true;
    }

    onChange(key, newValue) {
        this.setState({
            tmpData: {
                ...this.state.tmpData,
                [key]: newValue
            }
        });
    }


    onEdit() {
        this.setState({
            isDisabled: false,
            tmpData: this.state.data
        });
    }

    onCancel() {
        this.setState({
            isDisabled: true
        });
    }

    onSubmit() {
        console.log("onSubmit", this.state);
        //API
        this.props.onUpdate(this.state.tmpData);
        // window.open(this.props.history.createHref({
        //     pathname: "/proj/detail/" + this.state.pid
        // }));
    }

    getDom(index, value, key, currentData, isDisabled) {
        const onChange = this.onChange;
        // console.log(currentData);
        switch (value.type) {
            case ETYPE.NO_DATA:
                return (
                    <Col key={index} className="mb-2">
                        <label>{value.name}</label>
                        <div class="form-row">
                            <Col><input disabled type="text" class="form-control" placeholder="沒資料啊ＱＱ" /></Col>
                        </div>
                    </Col>
                );
            case ETYPE.EMPTY:
                return (<Col key={index} className="mb-78"></Col>);
            // return (<Col className="mb-2">
            //     <label>aa</label>
            //     <input class="form-control" type="text" value="" />
            // </Col>);
            case ETYPE.OPTIONS:
                return (
                    <ProjEditPtypeDom
                        isDisabled={isDisabled}
                        key={index}
                        dataKey={key}
                        data={value}
                        value={currentData[key]}
                        onChange={onChange}
                    />
                );
            case ETYPE.NUMBER:
                return (
                    <ProjEditNumberDom
                        isDisabled={isDisabled}
                        key={index}
                        dataKey={key}
                        data={value}
                        value={currentData[key]}
                        onChange={onChange}
                    />
                );
            case ETYPE.STRING:
                return (
                    <ProjEditStringDom
                        isDisabled={isDisabled}
                        key={index}
                        dataKey={key}
                        data={value}
                        value={currentData[key]}
                        onChange={onChange}
                    />
                );
            case ETYPE.TEXT_AREA:
                return (
                    <ProjEditTextareaDom
                        isDisabled={isDisabled}
                        key={index}
                        dataKey={key}
                        data={value}
                        value={currentData[key]}
                        onChange={onChange}
                    />
                );
            case ETYPE.IMAGE:
                return (
                    <ProjEditImageDom
                        isDisabled={isDisabled}
                        key={index}
                        dataKey={key}
                        data={value}
                        value={currentData[key]}
                        onChange={onChange}
                        pid={this.state.data.pid}
                    />
                );
            case ETYPE.IMAGE_ARY:
                return (
                    <ProjEditImageAryDom
                        isDisabled={isDisabled}
                        key={index}
                        dataKey={key}
                        data={value}
                        value={currentData[key]}
                        onChange={onChange}
                        pid={this.state.data.pid}
                    />
                );
            case ETYPE.TIME:
                return (
                    <ProjEditTimeDom
                        isDisabled={isDisabled}
                        key={index}
                        dataKey={key}
                        data={value}
                        value={currentData[key]}
                        onChange={onChange}
                    />
                );
            case ETYPE.INTERVAL:
                return (
                    <ProjEditIntervalDom
                        isDisabled={isDisabled}
                        key={index}
                        dataKey={key}
                        data={value}
                        year={currentData.interval_year || 0}
                        month={currentData.interval_month || 0}
                        day={currentData.interval_day || 0}
                        onChange={onChange}
                    />
                );
            // default:
            //     tmp.push( className="mb-2");
            //     break;
        }
    }

    onSwitchImgPopup() {
        this.setState({
            isShowImg: !this.state.isShowImg,
            tmpImg: null
        });
    }

    onSelectImg(url) {
        // this.onChange("icon", url);
        this.setState({
            tmpImg: url
        });
    }

    onConfirmImg() {
        // this.onChange("icon", url);
        this.setState({
            tmpData: {
                ...this.state.tmpData,
                tmpImg: null,
                icon: this.state.tmpImg,
                images: [this.state.tmpImg]
            }
        });
        this.onSwitchImgPopup();
    }

    render() {
        const { title, isAddProj } = this.props;
        const { data, isDisabled, tmpData, isShowImg } = this.state;
        // const { onChange } = this;
        const currentData = isDisabled ? data : tmpData;
        console.log(isDisabled, currentData);

        let listAryLeft = [
            // { key: "p_type", name: "問卷類型", isRequired: true, type: ETYPE.OPTIONS, options: ["一次性", "通行碼", "週期", "健康", "測試(訪查用)"] },
            { key: "name", name: "問卷名稱", isRequired: true, type: ETYPE.STRING },
            { key: "description", name: "問卷說明", isRequired: true, type: ETYPE.TEXT_AREA },
            { key: "end_page", name: "問卷結尾語", isRequired: true, type: ETYPE.STRING },
            { key: "start_at", name: "開始時間", isRequired: true, type: ETYPE.TIME },
            // { key: "end_at", name: "結束時間", isRequired: true, type: ETYPE.TIME },
        ];

        // console.log("[ProjectsAddCustAppForm] ", this.state);
        let tmpLeft = [];

        if (currentData) {
            for (const [index, value] of Object.entries(listAryLeft)) {
                const key = value.key;
                tmpLeft.push(this.getDom(index, value, key, currentData, isDisabled));
            }
        }

        return (
            <>
                {tmpLeft}
                <Row className="mt-3">
                    <Col className="text-left border">
                        {this.state.tmpData.icon ? (<img style={{ maxWidth: "100%" }} src={this.state.tmpData.icon} />) : null}
                    </Col>
                    <Col className="text-left">
                        <Button variant="danger" onClick={this.onSwitchImgPopup}>設定圖片</Button>
                    </Col>
                    <Col className="text-right">
                        <Button className="btn-blue" onClick={this.onSubmit}>{this.props.isAddProj ? "確定新增" : "儲存"}</Button>
                    </Col>
                </Row>
                <ProjAddCustTempImgs
                    show={this.state.isShowImg}
                    data={currentData}
                    tmpImg={this.state.tmpImg}
                    onSelect={this.onSelectImg}
                    onConfirmImg={this.onConfirmImg}
                    onSwitch={this.onSwitchImgPopup} />
                <Row className={"mt-3 mb-3"}></Row>
            </>
        );
    }
}
